<!-- Header -->

@if (loggedIn) {
<app-header></app-header>
}

<!--Menu-->
@if (loggedIn) {
<app-menubar></app-menubar>
}

<!-- Main Content -->
<main class="container" style="background-color: white">
  <div class="w-100">
    <div>
      <section id="column1" class="layout12">
        <app-success-toast></app-success-toast>
        <app-error-toast></app-error-toast>
        <div class="row justify-content-center">
          <span class="disclaimerText">
            Lessons Learned are Company Confidential. Please do not share
            externally without prior written approval.
          </span>
          <span class="bold">
            &nbsp; Content Contact:
            <a href="{{ contentContactUrl }}">{{ contentContactName }}</a>
          </span>
        </div>
        @if (loggedIn) {
        <router-outlet></router-outlet>
        }
      </section>
    </div>
    @if (!loggedIn) {
    <div
      class="d-flex justify-content-center align-items-center"
      style="min-height: 750px"
    >
      @if (initializationError) {
      <div class="text-center" role="alert">
        <p>{{ initializationError }}</p>
        <button class="btn btn-primary" type="button" (click)="retryUserProfileInitialization()">
          Try again
        </button>
      </div>
      } @else {
      <div>
        <mat-spinner></mat-spinner>
      </div>
      }
    </div>
    }
  </div>
</main>
<!-- CHATBOT TEMPORARILY DISABLED UNTIL RESULTS ARE MORE CONSISTENT WITH SEARCH RESULTS -->
<!-- @if (loggedIn) {
<app-chatbot-icon></app-chatbot-icon>
} -->
<!-- Footer -->
<app-footer
  [contentContactName]="contentContactName"
  [contentContactUrl]="contentContactUrl"
  [technicalContactName]="technicalContactName"
  [technicalContactUrl]="technicalContactUrl"
  [copyright]="copyright"
  [lastUpdate]="lastUpdate"
  [productUserGuide]="productUserGuide"
  [productUserGuideUrl]="productUserGuideUrl"
>
</app-footer>
